/* Search panel, set up to work like lechameau.com. Loaded by snippets/zr-quick-search.liquid.
   - Any link or empty search form pointing at /search (e.g. the header's search icon) opens the panel.
   - The panel slides in from the right on desktop and fills the screen width on mobile.
   - Before typing: "Popular searches" and "Popular products" (from <template id="zrqs-idle">).
   - While typing: "Did you mean?", products + "View all", then collections and pages
     with the typed words in bold (Shopify predictive search).
   - Enter or "View all" opens the full search results page.
   Previous version: assets/zr-quick-search-backup-before-lechameau.js */
(function () {
  if (window.__zrQuickSearch) return;
  window.__zrQuickSearch = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var searchPath = (root + 'search').replace(/\/+$/, '');
  var panel, backdrop, form, input, idle, live, lastFocus, timer, controller;

  var ICON_SEARCH = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><circle cx="8.5" cy="8.5" r="6" stroke="currentColor" stroke-width="1.5"/><path d="M13 13l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var ICON_CLOSE = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format(n);
    } catch (e) {
      return n.toFixed(2);
    }
  }

  function resultsUrl(q) {
    return root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  // Puts the typed words in bold inside a title ("Riding Hats" -> "<strong>Riding</strong> Hats").
  function highlight(text, q) {
    var safe = esc(text);
    var words = q.split(/\s+/).filter(function (w) { return w.length > 0; }).map(function (w) {
      return esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    if (!words.length) return safe;
    return safe.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<strong>$1</strong>');
  }

  function ssHeader() {
    return document.querySelector('[id*="__ss_header"] > div');
  }

  function headerBottom() {
    var max = 0;
    var els = document.querySelectorAll('[id*="__ss_header"] > div, .shopify-section-group-header-group');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.height > 0 && r.bottom > max) max = r.bottom;
    }
    return Math.max(0, Math.round(max));
  }

  function isSearchUrl(url) {
    var u;
    try { u = new URL(url, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    var p = u.pathname.replace(/\/+$/, '');
    if (p !== searchPath && p !== '/search') return null;
    return u;
  }

  function build() {
    backdrop = document.createElement('div');
    backdrop.className = 'zrqs-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    backdrop.addEventListener('click', close);

    panel = document.createElement('div');
    panel.className = 'zrqs';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Search');
    panel.innerHTML =
      '<div class="zrqs__head">' +
        '<form class="zrqs__form" action="' + root + 'search" method="get" role="search">' +
          '<label class="zrqs__label" for="zrqs-input">Search</label>' +
          '<span class="zrqs__icon">' + ICON_SEARCH + '</span>' +
          '<input class="zrqs__input" id="zrqs-input" type="search" name="q" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" enterkeyhint="search" placeholder="Search" aria-controls="zrqs-live">' +
          '<input type="hidden" name="options[prefix]" value="last">' +
        '</form>' +
        '<button type="button" class="zrqs__close" aria-label="Close search">' + ICON_CLOSE + '</button>' +
      '</div>' +
      '<div class="zrqs__body">' +
        '<div class="zrqs__live" id="zrqs-live" aria-live="polite" hidden></div>' +
        '<div class="zrqs__idle"></div>' +
      '</div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);

    form = panel.querySelector('.zrqs__form');
    input = panel.querySelector('.zrqs__input');
    idle = panel.querySelector('.zrqs__idle');
    live = panel.querySelector('.zrqs__live');

    var tpl = document.getElementById('zrqs-idle');
    if (tpl && tpl.content) idle.appendChild(tpl.content.cloneNode(true));

    panel.querySelector('.zrqs__close').addEventListener('click', close);

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(suggest, 200);
    });

    // Enter goes to the full results page; an empty box does nothing.
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) e.preventDefault();
    });

    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') trapFocus(e);
    });
  }

  function trapFocus(e) {
    var f = Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button, input:not([type="hidden"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function position() {
    var top = headerBottom();
    panel.style.top = top + 'px';
    backdrop.style.top = top + 'px';
  }

  function showIdle() {
    if (controller) controller.abort();
    panel.classList.remove('is-loading');
    live.hidden = true;
    live.innerHTML = '';
    idle.hidden = false;
  }

  function open(q) {
    if (!panel) build();
    lastFocus = document.activeElement;
    var h = ssHeader();
    if (h) h.classList.add('onscroll'); // solid header while searching (the homepage header is see-through)
    position();
    setTimeout(position, 300);
    document.documentElement.classList.add('zrqs-open');
    panel.classList.add('is-open');
    backdrop.classList.add('is-open');
    input.value = q || '';
    if (input.value.trim()) suggest(); else showIdle();
    setTimeout(function () { input.focus(); }, 50);
    window.addEventListener('resize', position);
  }

  function close() {
    if (!panel) return;
    panel.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.documentElement.classList.remove('zrqs-open');
    var h = ssHeader();
    if (h && window.scrollY < 20) h.classList.remove('onscroll');
    window.removeEventListener('resize', position);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function card(p) {
    var img = p.image;
    var from = p.price_max && parseFloat(p.price_max) > parseFloat(p.price);
    var compare = parseFloat(p.compare_at_price_max) > parseFloat(p.price);
    if (img && img.indexOf('width=') === -1) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=480';
    return '<li><a class="zrqs__card" href="' + esc(p.url) + '">' +
      '<span class="zrqs__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="zrqs__name">' + esc(p.title) + '</span>' +
      '<span class="zrqs__price">' + (from ? 'From ' : '') + esc(money(p.price)) +
        (compare && !from ? ' <s>' + esc(money(p.compare_at_price_max)) + '</s>' : '') +
        (p.available === false ? ' <span class="zrqs__soldout">Sold out</span>' : '') +
      '</span></a></li>';
  }

  function linkList(title, items, q) {
    // Collection titles like "Women / Hats / Hat Silks" show only their last part;
    // skip any that end up with the same name as one already listed.
    var seen = {};
    var rows = [];
    items.forEach(function (x) {
      var t = String(x.title || '').split('/').pop().trim();
      var key = t.toLowerCase();
      if (!t || seen[key] || rows.length >= 4) return;
      seen[key] = true;
      rows.push('<li><a href="' + esc(x.url) + '">' + highlight(t, q) + '</a></li>');
    });
    if (!rows.length) return '<div></div>';
    return '<div class="zrqs__section"><p class="zrqs__heading">' + title + '</p><ul class="zrqs__list" role="list">' + rows.join('') + '</ul></div>';
  }

  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [];
    var collections = r.collections || [];
    var pages = r.pages || [];
    var queries = (r.queries || []).filter(function (x) {
      return x.text && x.text.toLowerCase() !== q.toLowerCase();
    });
    var found = products.length || collections.length || pages.length;
    var html = '';

    if (!found) {
      html += '<p class="zrqs__empty">No results for &ldquo;' + esc(q) + '&rdquo;</p>';
    }

    if (queries.length) {
      html += '<div class="zrqs__section"><p class="zrqs__heading">Did you mean?</p><ul class="zrqs__pills" role="list">';
      queries.slice(0, 5).forEach(function (x) {
        html += '<li><a class="zrqs__pill" href="' + esc(resultsUrl(x.text)) + '">' + esc(x.text) + '</a></li>';
      });
      html += '</ul></div>';
    }

    if (products.length) {
      html += '<div class="zrqs__section"><p class="zrqs__heading">Products</p><ul class="zrqs__grid" role="list">';
      products.slice(0, 4).forEach(function (p) {
        html += card({
          title: p.title,
          url: p.url,
          image: (p.featured_image && p.featured_image.url) || p.image,
          price: p.price,
          price_max: p.price_max,
          compare_at_price_max: p.compare_at_price_max,
          available: p.available
        });
      });
      html += '</ul><a class="zrqs__all" href="' + esc(resultsUrl(q)) + '">View all</a></div>';
    }

    if (collections.length || pages.length) {
      html += '<div class="zrqs__cols">' + linkList('Collections', collections, q) + linkList('Pages', pages, q) + '</div>';
    }

    live.innerHTML = html;
    live.hidden = false;
    // with no matches, Popular searches / Popular products stay underneath the message
    idle.hidden = !!found;
  }

  function suggest() {
    var q = input.value.trim();
    if (!q) { showIdle(); return; }
    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product,collection,page,query&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last&resources%5Boptions%5D%5Bfields%5D=title,product_type,variants.title,vendor,tag';
    panel.classList.add('is-loading');
    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        panel.classList.remove('is-loading');
        if (input.value.trim() === q) render(q, d);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        panel.classList.remove('is-loading');
        live.innerHTML = '<p class="zrqs__empty">Search isn&rsquo;t available right now. Press Enter to see all results.</p>';
        live.hidden = false;
      });
  }

  // A link to the search page with no search words (e.g. the header's search icon) opens the panel.
  // Links that already carry search words go straight to the results page.
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || (panel && panel.contains(a))) return;
    var u = isSearchUrl(a.href);
    if (!u) return;
    if ((u.searchParams.get('q') || '').trim()) return;
    e.preventDefault();
    open('');
  }, true);

  // An empty search form elsewhere on the site opens the panel; a filled-in one searches as normal.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM' || (panel && panel.contains(f))) return;
    if (!isSearchUrl(f.getAttribute('action') ? f.action : '')) return;
    var field = f.querySelector('[name="q"]');
    if (!field) return;
    if (String(field.value || '').trim()) return;
    e.preventDefault();
    open('');
  }, true);
})();
